import React, { useEffect } from 'react';
import { LuShieldCheck } from "react-icons/lu";

const PrivacyPopup = ({ show, onAccept, onCancel }) => {
  // Escape schließt den Dialog
  useEffect(() => {
    if (!show) return;
    const onKey = (e) => { if (e.key === "Escape") onCancel(); };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [show, onCancel]);

  if (!show) return null;

  return (
    <div className="modal-backdrop" onClick={onCancel}>
      <div
        className="modal"
        role="dialog"
        aria-modal="true"
        aria-labelledby="privacy-title"
        onClick={e => e.stopPropagation()}
      >
        <span className="icon-tile icon-tile-lg"><LuShieldCheck size={24} aria-hidden="true" /></span>
        <h2 id="privacy-title" className="modal-title">Kurzer Datenschutzhinweis</h2>
        <div className="modal-body">
          <p>
            Die Verarbeitung erfolgt <strong>ausschließlich lokal im Browser</strong>.
            Es werden <strong>keinerlei Daten übertragen oder gespeichert</strong>.
          </p>
          <ul>
            <li>Dieses Tool ist nur für <strong>unkritische Test- und Lerndaten</strong> gedacht.</li>
            <li>Bitte <strong>keine Firmen-, personenbezogenen oder sensiblen Daten</strong> hochladen.</li>
            <li>Für eventuelle Fehler, Datenverluste oder Missbrauch <strong>übernehmen wir keine Haftung</strong>.</li>
          </ul>
        </div>
        <div className="modal-actions">
          <button type="button" className="btn btn-secondary" onClick={onCancel}>
            Abbrechen
          </button>
          <button type="button" className="btn btn-primary" onClick={onAccept} autoFocus>
            Verstanden, weiter
          </button>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPopup;
